// extracted by mini-css-extract-plugin
export default {"carouselRightArrow":"CarouselRightArrow_carouselRightArrow__gOkx0"};